export enum NavigationKey {
  Footer0 = 'footer0',
  Footer1 = 'footer1',
  HeaderBrands = 'headerBrands',
  MainNavigationPrimary = 'mainNavigationPrimary',
  MainNavigationSecondary = 'mainNavigationSecondary',
}
